import { gql } from "@apollo/client/core";
import { useMutation } from "@vue/apollo-composable";
import { MutationSendCodePinArgs, User } from "@/graphql/types";

type Data = {
  sendCodePin: User;
};

const MUTATION = gql`
  mutation SendCodePin($input: SendCodePinInput!) {
    sendCodePin(input: $input) {
      email
      resentTimes
    }
  }
`;

export const useSendCodePin = () => {
  const {
    loading,
    onDone,
    onError,
    mutate: sendCode,
  } = useMutation<Data, MutationSendCodePinArgs>(MUTATION, {
    fetchPolicy: "no-cache",
  });

  return {
    loading,
    onDone,
    onError,
    sendCode,
  };
};
